import React from 'react';

import { useLocation } from 'react-router-dom';
import UnauthorisedAccess from '../CommonComponents/UnauthorisedAccess';

import CustomerInfoCard from './CustomerInfoCard';
// import CustomerEditingActionCard from './CustomerEditingActionCard';
import CustomerSerialNumbers from './CustomerSerialNumbers';
import CustomerNotes from './CustomerNotes';

import Card from '@mui/material/Card';

export default function CustomerEditCustomer() {
  const [useType, setUseType] = React.useState(localStorage.getItem('type'));
  const location = useLocation();
  const customerData = location.state;
  // console.log(location);
  return useType === 'technician' ? (
    <UnauthorisedAccess />
  ) : (
    <Card
      md={{
        background: 'none',
        border: 'none',
        boxShadow: 'none',
        padding: '10px',
      }}
      // xs={{ padding: 0 }}
    >
      <CustomerInfoCard
        customerData={location.state}
        postUri={`/api/customersv2/${customerData.id}`}
        returnInfo={location.state.returnInfo}
      />
      <CustomerSerialNumbers serialCustomerId={customerData.id} />
      <CustomerNotes customerId={customerData.id} />
      {/* <CustomerEditingActionCard /> */}
    </Card>
  );
}
